import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6900Model } from "../kymw6900.model";
import { PagenationModel } from "../vo/pagenation.model";
import { ProposalModel } from "../vo/proposal.model";

export interface GetGoodsProposalInfoResponse {
  TotalNum: string;
  StartDispNum: string;
  EndDispNum: string;
  GoodsProposalList: {
    ProposalStatus: string,
    ReportOutputDate: string,
    ProposalUserId: string,
    AssociatedUserName: string,
    ProposalBuyerId: string,
    UserNmKanji: string,
    ClassCode: string,
    ExpansionStartSuggestedOrderCode?: string,
    DelivCatalogId?: string,
    PCode: string,
    ProposalGoodsName: string,
    ProposalName: string,
    MasterInputId: string,
    ProposalId: string,
    ItemCode: string;
  }[];
}

/**
 * 商品提案情報を取得するサービス
 *
 * @export GetGoodsProposalInfoService
 * @class GetGoodsProposalInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetGoodsProposalInfoService extends PlessJsonResponderSub<GetGoodsProposalInfoResponse> {
  private model: KYMW6900Model;
  private requestPage = 1;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsProposalInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ProposalStatus: this.model.confirmedSearchParams.proposalStatus,
        ProposalUserId: this.model.confirmedSearchParams.proposalUserId,
        ProposalGoodsNameStandardName: this.model.confirmedSearchParams.goodsNameAndStandardName,
        SuggestedOrderCode: this.model.confirmedSearchParams.preferredStartOrderCode,
        SuggestedCatalogId: this.model.confirmedSearchParams.preferredDelivCatalogId,
        ClassCode: this.model.confirmedSearchParams.classCode,
        ProposalBuyerId: this.model.confirmedSearchParams.buyerId,
        PCode: this.model.confirmedSearchParams.pcode,
        MasterInputStatus: this.model.confirmedSearchParams.masterInputStatus,
        Page: this.requestPage.toString()
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetGoodsProposalInfoService
   */
  execute(model: KYMW6900Model, requestPage: number): void {
    this.model = model;
    this.requestPage = requestPage;
    // データがないときのため事前に表を空にする
    this.model.proposalList = [];
    this.send('getGoodsProposalInfo', this.getBody());
  }

  /**
   * API通信成功時の処理 
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsProposalInfoService
   */
  success(data: GetGoodsProposalInfoResponse) {
    this.model.pagenation = new PagenationModel(this.requestPage, Number(data.TotalNum), Number(data.StartDispNum), Number(data.EndDispNum));
    this.model.proposalList = data.GoodsProposalList.map(p => {
      const proposalId = p.ProposalId;
      const proposalStatus = {
        code: this.model.proposalStatusList.find(s => s.CodeValue === p.ProposalStatus)?.CodeValue ?? '',
        name: this.model.proposalStatusList.find(s => s.CodeValue === p.ProposalStatus)?.CodeName ?? ''
      };
      const reportOutputDate = p.ReportOutputDate;
      const proposalUser = { userId: p.ProposalUserId, userName: p.AssociatedUserName };
      const classCode = this.model.classCodeList.find(c => c.ClassCode === p.ClassCode)?.ClassCodeName ?? '';
      const preferredStartOrderCode = p?.ExpansionStartSuggestedOrderCode ?? '';
      const preferredStartDelivCatalogId = p?.DelivCatalogId ?? '';
      const buyer = { buyerId: p.ProposalBuyerId, buyerName: p.UserNmKanji };
      const pcode = p.PCode ?? '';
      const itemCode = p.ItemCode ?? '';
      const goodsNameAndStandardName = `${p.ProposalGoodsName}・${p.ProposalName}`;
      const masterInputId = p.MasterInputId ?? '';
      const masterInputStatus = this.model.getMasterInputStatus(p.MasterInputId);

      return new ProposalModel(
        proposalId,
        proposalStatus,
        proposalUser,
        reportOutputDate,
        classCode,
        preferredStartOrderCode,
        preferredStartDelivCatalogId,
        buyer,
        pcode,
        itemCode,
        goodsNameAndStandardName,
        masterInputId,
        masterInputStatus
      );
    });
    this.model.isHeaderChecked = false;
    if (this.model.isClient() && this.model.proposalList[0]?.proposalId) {
      this.model.setDefaultSelectedProposalId(this.model.proposalList[0].proposalId);
    }
  }
}
